import http from "../../../../services/http-common";

export interface CustomerOption {
  customerId: number;
  initials: string;
  name: string;
}
export interface CustomerExecutiveParams {
  customerId: number;
  mode: "month" | "range";
  month?: number;
  year?: number;
  fromMonth?: number;
  fromYear?: number;
  toMonth?: number;
  toYear?: number;
}
export interface Treatment { lensId: number; name: string; billed: number; pairs: number; }
export interface CustomerMetrics {
  billed: number;
  monthlySeries: Array<{ month: string; total: number; [key: string]: string | number }>;
  arMix: Array<{ key: string; label: string; pairs: number; billed: number }>;
  premiumSeries: Array<{ month: string; premiumShare: number }>;
  treatments: Treatment[];
  orderTypes: { salePairs: number; courtesyPairs: number };
}
export interface CustomerExecutive {
  customer: CustomerOption;
  period: { mode: "month" | "range"; label: string };
  kpis: { postpaidBilled: number; prepaidConsumed: number; prepaidBalance: number | null; openOrders: number };
  all: CustomerMetrics;
  postpaid: CustomerMetrics;
  prepaid: CustomerMetrics;
}

class dashboardService {
  getCustomerExecutive(params: CustomerExecutiveParams) {
    return http.get<CustomerExecutive>("/dashboard/customer-executive", { params });
  }
  searchExecutiveCustomers(search: string) {
    return http.get<CustomerOption[]>("/dashboard/customer-executive/customers", { params: { search } });
  }

  getExecutive(params: {
    mode?: "month" | "range";
    month?: number;
    year?: number;
    fromMonth?: number;
    fromYear?: number;
    toMonth?: number;
    toYear?: number;
    branch: string;
  }) {
    return http.get("/dashboard/executive", { params });
  }

  getCustomerComparison(params: {
    mode?: "month" | "range";
    month?: number;
    year?: number;
    fromMonth?: number;
    fromYear?: number;
    toMonth?: number;
    toYear?: number;
    branch: string;
    search?: string;
  }) {
    return http.get("/dashboard/customers", { params });
  }

  getCustomerCompareDetail(params: {
    mode?: "month" | "range";
    month?: number;
    year?: number;
    fromMonth?: number;
    fromYear?: number;
    toMonth?: number;
    toYear?: number;
    branch: string;
    ids: string;
  }) {
    return http.get("/dashboard/customers/compare", { params });
  }
}

export default new dashboardService();
